var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tumeng-line-container",style:(_vm.wrapStyle)},[_c('canvas',{ref:"lineCanvas",attrs:{"width":_vm.conf.width,"height":_vm.conf.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }